import { render, staticRenderFns } from "./LetterCube.vue?vue&type=template&id=459d2d2c&scoped=true&"
import script from "./LetterCube.vue?vue&type=script&lang=js&"
export * from "./LetterCube.vue?vue&type=script&lang=js&"
import style0 from "./LetterCube.vue?vue&type=style&index=0&id=459d2d2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "459d2d2c",
  null
  
)

export default component.exports